import { render, staticRenderFns } from "./Freight.vue?vue&type=template&id=1c97dbdc&"
import script from "./Freight.vue?vue&type=script&lang=ts&"
export * from "./Freight.vue?vue&type=script&lang=ts&"
import style0 from "./Freight.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports